import moment from 'moment';

export default (): string => {
    return moment().local().toISOString(true);
};
